<template>
  <div class>
    <div class="contact-block">
      <div
        @click="contactDetails"
        class="show-contact"
        :class="{ open: contactHasOpen }"
      >
        <p>{{ contactName }}</p>
        <span class="otz-icon arrow-icon align-center-div">M</span>
        <!-- <span class="icon-item icon-location">9</span> -->
      </div>
      <div v-if="contactHasOpen" class="contact-details">
        <div v-if="job" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.job") }}</p>
          <p>{{ contactJob }}</p>
        </div>
        <div v-if="contactPhone" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.phone") }}</p>
          <p>{{ contactPhone }}</p>
        </div>
        <div v-if="contactPhone2" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.phone") }}</p>
          <div class="font-icon" style="padding-left:10px">
            <Icons icon="whatsapp" height="13px" width="13px" />
          </div>
          <a target="_blank" :href="'https://wa.me/' + whatapp">{{
            contactPhone2
          }}</a>
        </div>
        <div v-if="!abroad" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.extension") }}</p>
          <p>{{ contactExtension }}</p>
        </div>
        <div class="row-contact">
          <p class="title">{{ $t("staffContactDetails.email") }}</p>
          <p>{{ contactEmail }}</p>
        </div>
        <div v-if="!abroad" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.activityTime") }}</p>
          <p>{{ contactActivityTime }}</p>
        </div>
        <div v-if="abroad" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.address") }}</p>
          <p>{{ contactAddress }}</p>
        </div>
        <div v-if="abroad" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.country") }}</p>
          <p>{{ contactCountry }}</p>
        </div>
        <div v-if="abroad" class="row-contact">
          <p class="title">{{ $t("staffContactDetails.state") }}</p>
          <p>{{ contactSate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
export default {
  props: {
    contactName: String,
    contactJob: String,
    contactPhone: String,
    contactPhone2: String,
    contactExtension: String,
    contactEmail: String,
    contactActivityTime: String,
    contactAddress: String,
    contactCountry: String,
    contactSate: String,
    abroad: Boolean,
    job: Boolean,
    whatapp: String,
  },
  data() {
    return {
      contactHasOpen: false,
    };
  },
  components: { Icons },
  methods: {
    contactDetails() {
      this.contactHasOpen = !this.contactHasOpen;
    },
  },
  //ContactStaffMemberDetails
};
</script>

<style lang="scss" scoped>
.contact-block {
  // margin-right: 10px;
}
.show-contact {
  cursor: pointer;
  position: relative;
  transition: 0.3s;
  p {
    margin: 0;
    height: 38px;
    line-height: 38px;
    padding: 0 28px;

    border-bottom: 1px solid #e5e5e5;
  }
  .arrow-icon {
    width: auto;
    left: 10px;
    border-radius: 50%;
  }
  &.open {
    .arrow-icon {
      transform: translateY(-50%) rotate(180deg);
    }
    p {
      border: 0;
      color: var(--custom-color1);
    }
  }
}
.row-contact {
  display: flex;
  p {
    margin-left: 5px;
    line-height: 14px;
  }
  .title {
    color: #aaaaaa;
  }
}
.contact-details {
  padding: 0 28px 20px;
  border-bottom: 1px solid #e5e5e5;
}
</style>
